module.exports = __webpack_public_path__ + "static/img/ikonaPaint-ON.1309708d.png";